import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["legacy", "color", "disabled", "type"];
import React, { forwardRef } from 'react';
import { EzButtonLegacy, EzButtonMui } from './Implementations';
import buildDataAttributes from '../../utils/buildDataAttributes';
var EzButton = forwardRef(function (props, ref) {
  if (props.legacy === true) {
    var legacy = props.legacy,
      _props$color = props.color,
      _color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disabled = props.disabled,
      _disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$type = props.type,
      _type = _props$type === void 0 ? 'button' : _props$type,
      remainingProps = _objectWithoutProperties(props, _excluded);
    return React.createElement(EzButtonLegacy, _extends({
      ref: ref,
      color: _color,
      disabled: _disabled,
      type: _type
    }, remainingProps));
  }
  var _props$ariaHidden = props.ariaHidden,
    ariaHidden = _props$ariaHidden === void 0 ? false : _props$ariaHidden,
    ariaLabel = props.ariaLabel,
    children = props.children,
    _props$color2 = props.color,
    color = _props$color2 === void 0 ? 'primary' : _props$color2,
    data = props.data,
    _props$disabled2 = props.disabled,
    disabled = _props$disabled2 === void 0 ? false : _props$disabled2,
    endIcon = props.endIcon,
    _props$fontSize = props.fontSize,
    fontSize = _props$fontSize === void 0 ? 'medium' : _props$fontSize,
    _props$fullWidth = props.fullWidth,
    fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading,
    onClick = props.onClick,
    onKeyDown = props.onKeyDown,
    _props$size = props.size,
    size = _props$size === void 0 ? 'medium' : _props$size,
    startIcon = props.startIcon,
    _props$type2 = props.type,
    type = _props$type2 === void 0 ? 'button' : _props$type2,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'filled' : _props$variant;
  return React.createElement(EzButtonMui, _extends({
    ref: ref,
    ariaHidden: ariaHidden,
    ariaLabel: ariaLabel,
    color: color,
    disabled: disabled,
    endIcon: endIcon,
    fontSize: fontSize,
    fullWidth: fullWidth,
    loading: loading,
    onClick: onClick,
    onKeyDown: onKeyDown,
    size: size,
    startIcon: startIcon,
    type: type,
    variant: variant
  }, buildDataAttributes({
    data: data
  })), children);
});
EzButton.displayName = 'EzButton';
export default EzButton;